
import React from 'react'
import { Canvas } from '@react-three/fiber'
import  { Suspense } from 'react'
import {   PerspectiveCamera }  from '@react-three/drei'
import './App.css';

import useMediaQuery from '@material-ui/core/useMediaQuery';

import NavBar from "./2DComponents/NavBar";
import Contents from "./2DComponents/Contents";

import CustomCamera from './CustomCamera';
import Components3D from './Components3D';
import ParticleEffect from './2DComponents/ParticleEffect';
import ParticleEffectMobile from './2DComponents/ParticleEffectMobile';

export default function App(props) {

    const mobile = useMediaQuery('(max-width:960px)');

    function RenderDesktopParticles() {


        if(mobile)
            return <ParticleEffectMobile></ParticleEffectMobile>;
        else
            return <ParticleEffect></ParticleEffect>;
            
    }

    //canvas is the 3D scene. Components 2D are all the HTML elements camera projected, camera, and the wheel bheaviour
    //components 3D are all the 3D elements. These elements take as props the normalized scroll pos and direction, and the list with animation time
    return (
        <div
 
        >
            
            <div
                style={{
                    height: '100vh',
                    position:'fixed',
                    width:'100vw',
                    background:props.data.backgroundColor,
   
                }} 
                {...props}
            >
              
            </div>


            {RenderDesktopParticles()}
            
            <div
                style={{
                    width:'100vw',
                    height:'100vh',
                    position: 'fixed'
    
                }}
            
            >
                <Canvas>
                    <Suspense fallback={<></>}>
                    
                        <CustomCamera


                        />  
        
                        <Components3D


                            data={props.data}
     
                        
                        />

                        <PerspectiveCamera 

                            makeDefault={false}
                            position={[-1.5,1.5, 4.5]} 
                            rotation={[-0.4,-0.6,-0.4]}

                        />  

                    </Suspense>
    
                </Canvas>
            </div>

            <div
                style={{
                    color:'white',
                    backgroundColor: 'transparent' ,
                    height:'100vh',
                    width:'100vw',
                    position:'absolute',
                    top: '0em',
                            
                }}
            >
       
                <Contents
                ></Contents>              
            </div>


            <div
                
                style={{
                    position:'fixed',
                    width:'100vw'
                }}
            >
                <NavBar/>
            </div>


        </div>
  );
}
